
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/ecommerce/whatsapp",
      function () {
        return require("private-next-pages/integrations/ecommerce/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/ecommerce/whatsapp"])
      });
    }
  